import { createContext } from 'react';

/**
 * Context to provide menu-related information to child components.
 * Components like DownloadButton can check this context to decide
 * whether to render as MenuItem (inside menu) or Button (standalone),
 * and to access parent menu properties like actionPayload.
 */
export const MenuContext = createContext({
    isInsideMenu: false,
    actionPayload: null
});

export default MenuContext;
